<template>
  <modal
    ref="modalConfirmation"
    template="neutral"
    :icon-enabled="false"
    ref-name="modalConfirmation"
    :close-button-enabled="false"
    class="sample-modal-confirmation"
  >
    <button
      class="close-button btn-transparent"
      @click="closeModalConfirmation"
    >
      <md-icon>clear</md-icon>
    </button>
    
    <h3 class="sample-modal-confirmation__title">
      <button
        v-if="step2"
        class="btn-back btn-transparent"
        @click="backToPreviousStep"
      >
        <md-icon>arrow_back</md-icon>
      </button>

      <svg-loader
        class="icon-question-modal"
        src="/static/images/print-batch.svg"
      />

      Imprimir etiquetas
    </h3>
    <div
      v-if="step1"
      class="sample-modal-confirmation__step1"
    >
      <p class="sample-modal-confirmation__description">
        Esta(s) <b>{{ samplesQtd }} amostra(s)</b> está(ão) distribuida(s) em
        <b>{{ batchesQtd }} lote(s)</b>.<br>
        Você pode manter o(s) lote(s) aberto(s) e continuar adicionando
        amostras, ou fechá-lo(s) e iniciar um novo lote.
        <b>O que deseja fazer?</b>
      </p>

      <div class="sample-modal-confirmation__actions">
        <button
          class="btn-primary"
          @click="goToNextStep('no')"
        >
          Manter lote(s) aberto(s) e imprimir etiquetas
        </button>
        <button
          class="btn-primary"
          @click="goToNextStep('yes')"
        >
          Fechar o(s) lote(s) e imprimir etiquetas
        </button>
      </div>
    </div>

    <div
      v-if="step2"
      class="sample-modal-confirmation__step2"
    >
      <p class="sample-modal-confirmation__description">
        Você está prester a fechar os seguinte(s) lote(s):
        <ul class="sample-modal-confirmation__list">
          <li
            v-for="(arrayBatches, index) in batchesGroupedById"
            :key="index"
          >
            {{ arrayBatches[0].batch.label }}
          </li>
        </ul>
        <b>Deseja continuar?</b>
      </p>

      <div class="sample-modal-confirmation__actions">
        <button
          class="btn-primary"
          @click="done()"
        >
          Fechar e imprimir etiquetas
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'SampleModalConfirmation',
  data: () => ({
    samples: null,
    samplesQtd: 0,
    batchesQtd: 0,
    step1: true,
    step2: false,
    batchesGroupedById: null
  }),
  methods: {
    openModalConfirmation (data) {
      this.samples = data
      this.samplesQtd = data.length

      this.batchesGroupedById = data.reduce((objectsByKeyValue, obj) => {
        const value = obj['batch'].id
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
        return objectsByKeyValue
      }, {})

      this.batchesQtd = Object.keys(this.batchesGroupedById).length

      this.$refs.modalConfirmation.open()
    },
    closeModalConfirmation () {
      this.$refs.modalConfirmation.close()
      this.step1 = true
      this.step2 = false
      this.$emit('closeModal')
    },
    goToNextStep (answer) {
      if (answer === 'yes') {
        this.step1 = false
        this.step2 = true
      } else {
        this.closeModalConfirmation()
        this.printTags(answer)
      }
    },
    backToPreviousStep () {
      this.step1 = true
      this.step2 = false
    },
    printTags (answer) {
      this.$emit('printTags', answer, this.samples)
    },
    done () {
      this.closeModalConfirmation()
      this.printTags('yes')
    }
  }
}
</script>

<style lang="scss">
.sample-modal-confirmation {
  font-family: "Exo 2", sans-serif !important;

  .md-dialog {
    max-width: 480px;
  }

  .md-dialog-title {
    display: none;
  }

  .md-dialog-content {
    padding: 34px;
  }

  .close-button {
    z-index: 90;
    top: 15px;
    right: 24px;
  }

  .btn-back {
    color: #818181;
  }

  &__title {
    font-size: 20px;
    color: #4a4a4a;
    display: flex;
    align-items: center;

    i {
      margin: 0;
      margin-right: 15px;
    }
  }

  &__description {
    font-size: 16px;
    line-height: 24px;
    color: #4a4a4a;
    margin: 24px 0 !important;
  }

  &__list {
    padding-left: 12px;
    margin: 4px 0;

    li {
      list-style: inside;
      color: #7f1a54;
      text-transform: uppercase;
      line-height: 16px;
    }
  }

  &__actions {
    display: flex;
    justify-content: space-between;
    margin: 0 -7.5px;

    button {
      width: 50%;
      flex-grow: 1;
      flex-shrink: 1;
      margin: 0 7.5px;
      padding: 0 10px;
      font-family: "Exo 2", sans-serif !important;
      font-size: 12px;
      text-transform: uppercase;
      font-weight: 500;
    }
  }

  &__step2 {
    .sample-modal-confirmation__actions {
      display: flex;
      justify-content: center;

      button {
        flex-grow: 0;
      }
    }
  }
}
</style>
